


















import {Component, Prop, Vue} from 'vue-property-decorator';
import DetailMeter from '@/views/admin/meters/DetailMeter.vue';
import Meter from '@/data/models/meter';

@Component({
  components: {DetailMeter}
})
export default class MultipleMetersEdit extends Vue {
  @Prop({required: true})
  buildingId: string;

  selectedMeter: Meter = null;
  meters: Meter[] = [];

  mounted(): void {
    this.$dao.meters.getAllByBuilding(this.buildingId).then((result) => {
      if (result != null) {
        this.meters = result;
      } else {
        throw 'err';
      }
    });
  }

  get metersItem(): {text: string, value: Meter}[] {
    return this.meters?.filter((meter) => meter.referenceMeterId === null)?.map((meter) => ({text: meter.name, value: meter}));
  }
}
